import styled from "styled-components"

export default {
    "Wrapper": styled.main`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > h2 {
            ${({ theme }) => theme.font.medium_bold};

            & > span {
                color: ${({ theme }) => theme.color.major};
            }
        }
    `,

    "InputDiv": styled.div`
        display: flex;
        padding-bottom: 12px;
        border-bottom: 1px solid ${({ theme }) => theme.color.grey3};
        gap: 8px;

        & > input {
            width: 100%;
            ${({ theme }) => theme.font.small};
            
            &::placeholder {
                color: ${({ theme }) => theme.color.grey3};
            }
        }

        & > div {
            width: fit-content;
        }
    `,
}